module.exports = __webpack_public_path__ + "img/settings.48c89b11.svg";